module.exports = __webpack_public_path__ + "static/media/rejected-candidates.e9c8681f.svg";